import { createReducer, on } from '@ngrx/store';
import { clearBranchId, setBranchId } from './branch.actions';

export interface BranchState {
  branch_id: string|null;
}

export const initialBranchState: BranchState = {
  branch_id: ''
};

export const branchReducer = createReducer(
  initialBranchState,
  on(setBranchId, (state, { branch_id }) => ({ ...state, branch_id })),
  on(clearBranchId, (state) => ({
    ...state,
    branch_id: null
  }))
);